import React from "react";
import styled from "styled-components";
import { BiMenu } from "react-icons/bi";

interface Props {
    onClickHandler: () => void;
}

const AdminFAB: React.FC<Props> = ({ onClickHandler }) => {
    return (
        <FABContainer onClick={onClickHandler}>
            <BiMenu />
        </FABContainer>
    );
};

export default AdminFAB;

const FABContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 0px 20px 20px rgba(231, 231, 231, 0.5);

    position: fixed;
    right: 1rem;
    bottom: 1rem;

    border-radius: 4rem;
    height: 3.6rem;
    width: 3.6rem !important;

    background: ${(props) => props.theme.colors.primary[300]};

    & > * {
        height: 1.5rem;
        width: 1.5rem;
        color: ${(props) => props.theme.colors.neutral[50]};
    }

    &:hover {
        cursor: pointer;
        background: ${(props) => props.theme.colors.primary[200]};
    }

    @media (min-width: 768px) {
        display: none;
    }
`;
